import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Dialog, Grid, makeStyles } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import moment from 'moment';
import axiosInstance, { EVENT_ID, getEventId, WEB_API } from '../constatns';
import TableToolBarCustom from '../components/MuiDataTableCustom/TableToolBarCustom';
import TableFilterList from '../components/MuiDataTableCustom/TableFilterList';
import TableToolbarSelect from '../components/MuiDataTableCustom/TableToolbarSelect';
import { Create, Delete, PersonAdd } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import swal from '@sweetalert/with-react';
import FreePaperSubmissionForm from '../freepaper/FreePaperSubmissionForm';
import PaperReviewJudgeAdd from './PaperReviewJudgeAdd';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
}));

const PaperReviewJudge = (props) => {
  const { history } = props;
  const classes = useStyles();
  const [data, setData] = useState();
  const [alldata, setAllData] = useState();
  const [open, setOpen] = useState(false);

  let cols = [
    {
      name: 'id',
      label: 'No',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return tableMeta.tableData.length - tableMeta.rowIndex;
        },
      },
    },
    {
      name: 'memNo',
      label: 'RegNum',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'in_name_en',
      label: 'Name(Kor)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {value}
              <div>{'(' + tableMeta.tableData[tableMeta.rowIndex].username + ')'}</div>
            </div>
          );
        },
      },
    },
    {
      name: 'email',
      label: 'ID(E-mail)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'positionEn',
      label: '소속 / Affiliation',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {value}
              <div>{'(' + tableMeta.tableData[tableMeta.rowIndex].position + ')'}</div>
            </div>
          );
        },
      },
    },
    {
      name: 'id',
      label: '관리',
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <IconButton aria-label="delete" onClick={() => setDeleteAction(tableMeta)}>
                <Delete />
              </IconButton>
            </div>
          );
        },
      },
    },
  ];

  const setDeleteAction = (meta) => {
    swal({
      title: '정말 심사위원을 삭제하시겠습니까?',
      text: '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const updateParam = {
          evt: EVENT_ID,
          userId: data[meta.rowIndex].id,
          isReviewer: false,
        };
        axiosInstance.put(`${WEB_API}/user/`, updateParam).then((data) => {
          getMemberData();
        });
      }
    });
  };

  const onAssign = () => {
    alert('onAssign');
  };

  const handleClose = () => {
    setOpen(false);
    getMemberData();
  };

  const options = {
    print: false,
    search: false,
    searchOpen: false,
    filter: false,
    download: false,
    viewColumns: false,
    selectableRows: 'none',
    downloadOptions: {
      filename: `Abstract_Review_${moment().valueOf()}.csv`,
    },
    onRowsDelete: () => {
      onAssign();
      return false;
    },
    customSearch: (searchQuery, currentRow, columns) => {
      let isFound = false;
      data.map((member) => {
        if (member.id === currentRow[0]) {
          for (const [key, value] of Object.entries(member)) {
            if (typeof value === 'string') {
              if (value.indexOf(searchQuery) !== -1) isFound = true;
            }
          }
        }
      });
      return isFound;
    },
    onDownload: (buildHead, buildBody, columns, _data) => {
      return '\uFEFF' + buildHead(columns) + buildBody(_data);
    },
  };

  const getMemberData = () => {
    axiosInstance.get(`${WEB_API}/user/list?eventId=${getEventId()}&limit=-1`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      const arrData = response.data.Items.sort((a, b) => {
        return Number(b.createdAt) - Number(a.createdAt);
      });
      const reviewer = arrData.filter((d) => d.isReviewer);
      setData(reviewer);
      setAllData(arrData);
    });
  };

  useEffect(() => {
    getMemberData();
  }, []);

  return (
    <Grid item xs={12}>
      <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
        <Grid item>
          <Grid container spacing={4} justifyContent={'flex-start'} alignItems={'center'}>
            <Grid item>
              <ButtonGroup color="primary" disableElevation>
                <Button variant={'outlined'} onClick={() => setOpen(true)} startIcon={<PersonAdd />}>
                  심사위원 등록
                </Button>
              </ButtonGroup>
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ marginTop: 20 }}>
          <MUIDataTable
            title={''}
            data={data}
            columns={cols}
            options={options}
            components={{ TableToolbar: TableToolBarCustom, TableToolbarSelect: TableToolbarSelect }}
          />
        </Grid>
      </Grid>
      {open ? (
        <Dialog
          open={open}
          maxWidth={'lg'}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <PaperReviewJudgeAdd infoData={alldata} handleClose={handleClose} />
        </Dialog>
      ) : null}
    </Grid>
  );
};

export default PaperReviewJudge;
